package com.solevo.dist.application.models

sealed class InvoiceStatus(val value: String) {
    data object Overdue : InvoiceStatus("Overdue")
    data object DueToPay : InvoiceStatus("DueToPay")
    data object Closed : InvoiceStatus("Closed")

    companion object {
        fun fromString(value: String): InvoiceStatus {
            return when (value) {
                "Overdue" -> Overdue
                "DueToPay" -> DueToPay
                "Closed" -> Closed
                else -> throw IllegalArgumentException("Invalid InvoiceStatus value: $value")
            }
        }
    }
}